import { isomorphicConfig } from '@utils/isomorphic_config';

export const RECAPTCHA_REQUIRED_MESSAGE =
  'Please complete the reCAPTCHA challenge and try again.';

export const isRecaptchaEnabled = (): boolean => {
  try {
    return Boolean(isomorphicConfig().recaptchaEnabled);
  } catch {
    return false;
  }
};

export const getRecaptchaSiteKey = (): string => {
  try {
    return isomorphicConfig().recaptchaSiteKey || '';
  } catch {
    return '';
  }
};

/** @returns reCAPTCHA response token, or null when challenge is disabled */
const getRecaptchaToken = (): string | null => {
  if (!isRecaptchaEnabled()) return null;
  if (typeof grecaptcha === 'undefined') return null;
  if (typeof grecaptcha.enterprise?.getResponse !== 'function') return null;
  const token = grecaptcha.enterprise.getResponse();
  return token || null;
};

/** @throws {Error} when landing reCAPTCHA is enabled but unsolved */
export const requireRecaptchaToken = (): string | null => {
  const token = getRecaptchaToken();
  if (isRecaptchaEnabled() && !token) {
    throw new Error(RECAPTCHA_REQUIRED_MESSAGE);
  }
  return token;
};

export const resetRecaptcha = (): void => {
  if (typeof grecaptcha === 'undefined') return;
  if (typeof grecaptcha.enterprise?.reset !== 'function') return;
  grecaptcha.enterprise.reset();
};
